import Link from 'next/link';
import styled from 'styled-components';

export const HeaderReservationsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  &:hover {
    opacity: 0.75;
  }

  & > span {
    color: ${({ theme }) => theme.palette.white};
    font-size: 12px;
    font-weight: 600;
    line-height: 16px;
  }
`;

export const OnlineTransactionLinksWrapper = styled.div`
  display: flex;
  flex-direction: column;

  & > a {
    padding: 13px 27px;
    margin: 0px;

    &:hover {
      color: rgba(0, 0, 0, 0.88);
      background-color: rgba(0, 0, 0, 0.04);
    }
  }
`;

export const OnlineTransactionHeader = styled.div`
  color: ${({ theme }) => theme.palette.grey1100};
  font-size: 14px;
  font-weight: 700;
  line-height: 24px;
`;

export const OnlineTransactionLink = styled(Link)`
  padding: 12px 0px;
  color: ${({ theme }) => theme.palette.grey1100};
  font-size: 14px;
  font-weight: 500;
  line-height: 24px;

  &:hover {
    opacity: 0.75;
    color: ${({ theme }) => theme.palette.grey1100};
  }

  @media (max-width: ${({ theme }) => theme.breakPoint.LARGE_1X}) {
    color: ${({ theme }) => theme.palette.white} !important;
    font-size: 12px;
    font-weight: 600;
    line-height: 16px;
  }
`;

export const MobileHeaderReservationsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
